import React from 'react';
import { Button, Space, Tooltip, Modal } from 'antd';
import { ActionButtonProps } from './types';

export const ActionButton: React.FC<{ actions: ActionButtonProps[] }> = ({
  actions,
}) => {
  const handleActionClick = (action: ActionButtonProps) => {
    if (action.confirmMessage) {
      Modal.confirm({
        title: 'Confirm Action',
        content: action.confirmMessage,
        okText: 'Confirm',
        cancelText: 'Cancel',
        onOk: () => action.onClick(),
      });
    } else {
      action.onClick();
    }
  };

  return (
    <Space size="small">
      {actions.map(action => (
        <Tooltip key={action.key} title={action.tooltip}>
          <Button
            type={action.type || 'default'}
            size="small"
            icon={action.icon}
            danger={action.danger}
            onClick={() => handleActionClick(action)}
          >
            {action.label}
          </Button>
        </Tooltip>
      ))}
    </Space>
  );
};
